import manageJss from "@microsoft/fast-jss-manager-react";
import { Column as BaseColumn, } from "./column";
const Column = manageJss()(BaseColumn);
export { Column, };
